module.exports = __webpack_public_path__ + "static/media/ic_searchtype_anchoragetrans.ddec534c.svg";